export default __webpack_public_path__ + "static/media/DSC_7509.d3cfcd40.jpg";